<mat-dialog-content>
    <p>
        {{message}}
    </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button class="btn btn-danger" mat-raised-button (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
    <button mat-stroked-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>
